<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Recaudación Diaria</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button type="button" @click="consultar" class="btn-info">
            <i class="fa fa-search"></i><span>Consultar</span>
          </button>
          <button type="button" @click="exportar" class="btn-success">
            <i class="fa fa-file-excel-o"></i><span>Excel</span>
          </button>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12 col-md-4">
            <div class="form-field select">
              <div class="select-field">
                <select
                  name="tipo_fecha"
                  id="tipo_fecha"
                  v-model="form.tipo_fecha"
                >
                  <option value="H">Hoy</option>
                  <option value="A">Ayer</option>
                  <option value="P">Personalizado</option>
                </select>
                <label for="tipo_fecha">Tipo de fecha</label>
              </div>
            </div>
          </div>
          <div v-show="form.tipo_fecha === 'P'" class="col-xs-12 col-md-4">
            <div class="form-field">
              <div class="datepicker-field">
                <VueCtkDateTimePicker
                  id="desde"
                  v-model="form.desde"
                  locale="es"
                  no-label
                  only-date
                  button-now-translation="Ahora"
                  format="YYYY-MM-DD"
                  formatted="YYYY-MM-DD"
                  label="Seleccione fecha..."
                />
                <label>Desde</label>
              </div>
            </div>
          </div>
          <div v-show="form.tipo_fecha === 'P'" class="col-xs-12 col-md-4">
            <div class="form-field">
              <div class="datepicker-field">
                <VueCtkDateTimePicker
                  id="hasta"
                  v-model="form.hasta"
                  locale="es"
                  no-label
                  only-date
                  button-now-translation="Ahora"
                  format="YYYY-MM-DD"
                  formatted="YYYY-MM-DD"
                  label="Seleccione fecha..."
                />
                <label>Hasta</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div class="form-field select2 select2-field--stretch">
              <div class="select2-field">
                <v-select
                  :filterable="false"
                  @input="inputBodega"
                  label="descripcion"
                  placeholder="Seleccione..."
                  :options="bodegas"
                  id="bodegas"
                  v-model="selectedBodega"
                ></v-select>
                <label for="bodegas">Sucursal</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div class="form-field select2">
              <div class="select2-field">
                <v-select
                  :filterable="false"
                  @search="onSearchUsuarios"
                  @input="inputRecaudador"
                  label="nombre"
                  placeholder="Seleccione..."
                  :options="recaudadores"
                  id="usuarios"
                  v-model="selectedRecaudador"
                ></v-select>
                <label for="usuarios">Recaudador</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="recaudaciones.length > 0" class="card">
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12">
            <div style="max-height: 300px" class="table-responsive">
              <table class="custom-table">
                <thead>
                  <tr>
                    <th>Recaudador</th>
                    <th v-for="(registro, index) in registros" :key="index">
                      {{ index }}
                    </th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    :key="recaudador.nombre_recaudador"
                    v-for="recaudador in recaudaciones"
                  >
                    <td>
                      {{ recaudador.nombre_recaudador }}
                    </td>
                    <td v-for="(registro, index) in registros" :key="index">
                      {{
                        recaudador[index] != null
                          ? moneyFormat(recaudador[index])
                          : ""
                      }}
                    </td>
                    <td>
                      <strong>{{ moneyFormat(recaudador.total) }}</strong>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <th scope="row">Total</th>
                    <td v-for="(registro, index) in registros" :key="index">
                      <strong>{{ moneyFormat(obtenerTotalDia(index)) }}</strong>
                    </td>
                    <td>
                      <strong>{{ moneyFormat(totalRecaudado) }}</strong>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    bodegas: {
      required: true,
    },
  },
  data: function () {
    return {
      registros: [],
      recaudadores: [],
      selectedBodega: null,
      selectedRecaudador: null,
      form: {
        tipo_fecha: "P",
        desde: moment(new Date()).format("YYYY-MM-DD"),
        hasta: moment(new Date()).format("YYYY-MM-DD"),
        bodega_id: "",
        recaudador_id: "",
        tipo_reporte: "N",
      },
      recaudaciones: [],
      moneyFormat: moneyFormat,
    };
  },
  methods: {
    obtenerTotalDia: function (dia) {
      let total = 0;
      for (let i = 0; i < this.recaudaciones.length; i++) {
        if (this.recaudaciones[i][dia] != null) {
          total += this.recaudaciones[i][dia];
        }
      }
      return round(total, 2);
    },
    onSearchUsuarios: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.recaudadores = json;
          loading(false);
        } else loading(false);
      };
      let urlApi = `${url}/search/usuarios?search=${search}&tipo=R`;
      xmlhttp.open("GET", urlApi, true);
      xmlhttp.send();
    },
    inputRecaudador: function () {
      if (this.selectedRecaudador != null)
        this.form.recaudador_id = this.selectedRecaudador.id;
      else this.form.recaudador_id = "";
    },
    inputBodega: function () {
      if (this.selectedBodega != null)
        this.form.bodega_id = this.selectedBodega.id;
      else this.form.bodega_id = "";
    },
    exportar: function () {
      this.form.tipo_reporte = "E";
      let urlApi = `${url}/recaudacion-diaria${this.serialize(this.form)}`;
      window.open(urlApi, "_blank");
    },
    consultar: function () {
      this.form.tipo_reporte = "N";
      let urlApi = `${url}/recaudacion-diaria`;
      axios
        .get(urlApi, {
          params: this.form,
        })
        .then(({ data }) => {
          this.registros = data;
          let recaudaciones = [];
          for (let key in this.registros) {
            for (let i = 0; i < this.registros[key].length; i++) {
              recaudaciones.push(this.registros[key][i]);
            }
          }
          recaudaciones = _.groupBy(recaudaciones, function (b) {
            return b.nombre_recaudador;
          });
          let recaudadores = [];
          for (let key in recaudaciones) {
            let obj = {
              nombre_recaudador: key,
              total: 0,
            };
            let total = 0;
            for (let i = 0; i < recaudaciones[key].length; i++) {
              let valor = parseFloat(recaudaciones[key][i].valor_abono);
              total += valor;
              obj[recaudaciones[key][i].dia_abono] = valor;
            }
            obj.total = total;
            recaudadores.push(obj);
          }
          this.recaudaciones = recaudadores;
        })
        .catch(() => {
          swal("Error", "Hubo un error, intente nuevamente.", "error");
        });
    },
    serialize: function (obj) {
      return (
        "?" +
        Object.keys(obj)
          .reduce(function (a, k) {
            let val = obj[k];
            let esArray = false;
            if (val instanceof Date) {
              val = val.toLocaleDateString("en");
            } else if (val instanceof Array) {
              esArray = true;
              let acumulador = "";
              for (let i = 0; i < val.length; i++) {
                acumulador += k + "%5B%5D=" + val[i];
                if (i != val.length - 1) {
                  acumulador += "&";
                }
              }
              val = acumulador;
              a.push(val);
            }
            if (!esArray) a.push(k + "=" + encodeURIComponent(val));
            return a;
          }, [])
          .join("&")
      );
    },
  },
  computed: {
    totalRecaudado: function () {
      let total = 0;
      for (let i = 0; i < this.recaudaciones.length; i++) {
        total += this.recaudaciones[i].total;
      }
      return round(total, 2);
    },
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/pedidos/RecaudacionDiaria.vue